import { useEffect, useState } from "react";

export function getStorageValue(key, defaultValue) {
  // getting stored value
  const saved = localStorage.getItem(key);
  if (saved === null) return defaultValue;

  // Handle boolean strings
  if (saved === "true") return true;
  if (saved === "false") return false;

  return saved || defaultValue;
}

export async function setStorageValue(key, value) {
  if (value === null || value === undefined || value === "") {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
}

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    setStorageValue(key, value);
  }, [key, value]);

  return [value, setValue];
};
